export default {
  init() {
    let bookWrap = $('.book-wrap');
    if (bookWrap.length) {
      // const bookTabs = bookWrap.find('.book-tabs');
      // const selectedTab = bookTabs.find('.tab#menu-booking-' + bookTabTarget + '-tab');
      // const tabContent = bookWrap.find('.tab-content');
      // const tabPane = tabContent.find('.tab-pane');

      // bookTabs.find('.tab').removeClass('active show');
      // selectedTab.trigger('click');

      $('.tab', bookWrap).on('click', function (e) {
        e.preventDefault();
        let _this  = $(this);
        let target = _this.attr('href');

        _this.siblings().removeClass('active');
        $(this).addClass('active');

        $(target).siblings().removeClass('active show').fadeOut(100);
        $(target).addClass('active show ').fadeIn(100);
      });
    }
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/components/tabs.js